<template>
    <div>
        <teleport to="body">
            <transition name="fade">
                <div v-if="visible" class="app-new-user-overlay flex-col-center" @click.stop="close">
                    <div class="app-new-user-container">
                        <div class="app-new-user-card relative">
                            <img src="@/assets/images/other/dazzlinglight.webp" alt=""
                                class="app-new-user-background w-100% absolute top-0 left-0 h-100%">
                            <img src="@/assets/images/other/baoshi.webp" alt=""
                                class="app-new-user-gem w-100px h-100px mt-50px">
                            <div class="app-new-user-text">
                                +{{ amount || userStore.getMsgCost() }} Gems
                            </div>

                        </div>
                    </div>
                    <div class="app-new-user-btn" @click="close">
                        OK
                    </div>
                </div>
            </transition>
        </teleport>
    </div>
</template>
<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import { useDialogStore } from '@/stores/dialog'

const props = withDefaults(defineProps<{
    show?: boolean
    amount?: number
    isNewUser?: boolean
}>(), {
    show: undefined,
    amount: 0,
    isNewUser: true
})

const emit = defineEmits(['update:show'])
const dialogStore = useDialogStore()
const userStore = useUserStore()
// 如果传入了 show prop，使用 prop；否则使用 store
const visible = computed({
    get: () => {
        if (props.show !== undefined) {
            return props.show
        }
        return dialogStore.showAppNewUser
    },
    set: (val: boolean) => {
        if (props.show !== undefined) {
            emit('update:show', val)
        } else {
            if (val) {
                dialogStore.openAppNewUser()
            } else {
                dialogStore.closeAppNewUser()
            }
        }
    }
})



/**
 * 关闭新用户弹窗
 */
const close = () => {
    visible.value = false
    if (props.isNewUser) {
    }
}
</script>

<style scoped lang="scss">
.app-new-user-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;

    .app-new-user-container {
        width: 220px;
        height: 220px;
        animation: containerPopIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        animation-fill-mode: both;

        @keyframes containerPopIn {
            0% {
                transform: scale(0.3) rotate(-10deg);
                opacity: 0;
            }

            50% {
                transform: scale(1.1) rotate(5deg);
            }

            100% {
                transform: scale(1) rotate(0deg);
                opacity: 1;
            }
        }

        .app-new-user-card {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            overflow: hidden;

            .app-new-user-background {
                object-fit: cover;
                
                z-index: 0;
                animation: backgroundRotateScale 8s linear infinite;
                animation-delay: 0.6s;

                @keyframes backgroundRotateScale {
                    0% {
                        transform: rotate(0deg) scale(1);
                    }
                    12.5% {
                        transform: rotate(45deg) scale(1.2);
                    }
                    25% {
                        transform: rotate(90deg) scale(0.85);
                    }
                    37.5% {
                        transform: rotate(135deg) scale(1.15);
                    }
                    50% {
                        transform: rotate(180deg) scale(0.9);
                    }
                    62.5% {
                        transform: rotate(225deg) scale(1.1);
                    }
                    75% {
                        transform: rotate(270deg) scale(0.95);
                    }
                    87.5% {
                        transform: rotate(315deg) scale(1.18);
                    }
                    100% {
                        transform: rotate(360deg) scale(1);
                    }
                }
            }

            .app-new-user-gem {
                position: relative;
                z-index: 1;
                animation: gemFloat 2s ease-in-out infinite;
                animation-delay: 0.6s;
                animation-fill-mode: both;
                filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.6));

                // @keyframes gemFloat {

                //     0%,
                //     100% {
                //         transform: translateY(0) rotate(0deg) scale(1);
                //     }

                //     25% {
                //         transform: translateY(-8px) rotate(5deg) scale(1.05);
                //     }

                //     50% {
                //         transform: translateY(-12px) rotate(0deg) scale(1.1);
                //     }

                //     75% {
                //         transform: translateY(-8px) rotate(-5deg) scale(1.05);
                //     }
                // }
            }

            .app-new-user-text {
                position: relative;
                z-index: 1;
                font-weight: 800;
                font-size: 20px;
                color: #FFFFFF;
                text-shadow: 0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(255, 215, 0, 0.6);
            }
        }
    }

    .app-new-user-btn {
        font-size: 16px;
        font-weight: bold;
        width: 150px;
        height: 36px;
        background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        cursor: pointer;
        pointer-events: auto;
        animation: btnSlideUp 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        animation-fill-mode: both;
        transition: transform 0.2s, box-shadow 0.2s;
        box-shadow: 0 4px 15px rgba(90, 104, 255, 0.4);
        position: absolute;
        bottom: 28%;
        left: 30%;
        transform: translate(-50%, 50%);

        @keyframes btnSlideUp {
            0% {
                transform: translateY(30px) scale(0.8);
                opacity: 0;
            }

            100% {
                transform: translateY(0) scale(1);
                opacity: 1;
            }
        }

        &:hover {
            transform: scale(1.05);
            box-shadow: 0 6px 20px rgba(90, 104, 255, 0.6);
        }

        &:active {
            transform: scale(0.98);
        }
    }
}

// Fade transition
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>